export default __webpack_public_path__ + "static/media/A9204772.f7c5a58a.jpg";